import { useEffect, useState } from "react";

/**
 * Returns `true` after the first client render so consumers can avoid
 * SSR-mismatch flicker (e.g. when reading `next-themes` `resolvedTheme`).
 *
 * Extracted so the v6 landing components don't each re-declare the same
 * mounted-flag dance.
 */
export function useMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
}
